// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'


// Initialize Firebase
const config = {
  apiKey: 'AIzaSyAsnDMyQllianOj0ZS5v8xBPTAeaG2Dp60',
  authDomain: 'evolugy2020.web.app',
  databaseURL: 'https://evolugy2020.firebaseio.com/',
  projectId: 'evolugy2020',
  storageBucket: 'gs://evolugy2020.appspot.com',
  messagingSenderId: '293130554396'
}

firebase.initializeApp(config)


